/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ApiConfiguration } from "../api-configuration";
import { BaseService } from "../base-service";
import { createContact } from "../fn/contacts/create-contact";
import { CreateContact$Params } from "../fn/contacts/create-contact";
import { deleteContact } from "../fn/contacts/delete-contact";
import { DeleteContact$Params } from "../fn/contacts/delete-contact";
import { readContact } from "../fn/contacts/read-contact";
import { ReadContact$Params } from "../fn/contacts/read-contact";
import { readContacts } from "../fn/contacts/read-contacts";
import { ReadContacts$Params } from "../fn/contacts/read-contacts";
import { updateContact } from "../fn/contacts/update-contact";
import { UpdateContact$Params } from "../fn/contacts/update-contact";
import { ContactDetails } from "../models/contact-details";
import { ContactRead } from "../models/contact-read";
import { Status } from "../models/status";
import { StrictHttpResponse } from "../strict-http-response";

@Injectable({ providedIn: "root" })
export class ContactsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `readContacts()` */
  static readonly ReadContactsPath = "/surfdomeinen/organisations/{organisation_id}/contacts/";

  /**
   * Read Contacts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `readContacts()` instead.
   *
   * This method doesn't expect any request body.
   */
  readContacts$Response(
    params: ReadContacts$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<ContactRead>>> {
    const obs = readContacts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Read Contacts.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `readContacts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  readContacts(params: ReadContacts$Params, context?: HttpContext): Observable<Array<ContactRead>> {
    const resp = this.readContacts$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<Array<ContactRead>>): Array<ContactRead> => r.body));
  }

  /** Path part for operation `createContact()` */
  static readonly CreateContactPath = "/surfdomeinen/organisations/{organisation_id}/contacts/";

  /**
   * Create Contact.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createContact$Response(
    params: CreateContact$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<ContactDetails | Status>> {
    const obs = createContact(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create Contact.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createContact(params: CreateContact$Params, context?: HttpContext): Observable<ContactDetails | Status> {
    const resp = this.createContact$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<ContactDetails | Status>): ContactDetails | Status => r.body));
  }

  /** Path part for operation `readContact()` */
  static readonly ReadContactPath = "/surfdomeinen/organisations/{organisation_id}/contacts/{contact_id}";

  /**
   * Read Contact.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `readContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  readContact$Response(
    params: ReadContact$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<ContactDetails>> {
    const obs = readContact(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Read Contact.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `readContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  readContact(params: ReadContact$Params, context?: HttpContext): Observable<ContactDetails> {
    const resp = this.readContact$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<ContactDetails>): ContactDetails => r.body));
  }

  /** Path part for operation `deleteContact()` */
  static readonly DeleteContactPath = "/surfdomeinen/organisations/{organisation_id}/contacts/{contact_id}";

  /**
   * Delete Contact.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteContact$Response(params: DeleteContact$Params, context?: HttpContext): Observable<StrictHttpResponse<Status>> {
    const obs = deleteContact(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete Contact.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteContact(params: DeleteContact$Params, context?: HttpContext): Observable<Status> {
    const resp = this.deleteContact$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<Status>): Status => r.body));
  }

  /** Path part for operation `updateContact()` */
  static readonly UpdateContactPath = "/surfdomeinen/organisations/{organisation_id}/contacts/{contact_id}";

  /**
   * Update Contact.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContact$Response(
    params: UpdateContact$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<ContactDetails | Status>> {
    const obs = updateContact(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update Contact.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContact(params: UpdateContact$Params, context?: HttpContext): Observable<ContactDetails | Status> {
    const resp = this.updateContact$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<ContactDetails | Status>): ContactDetails | Status => r.body));
  }
}
